<template>
    <Cell class="WebhooksTableActionCell">
        <div v-if="isEditing" class="flex gap-1">
            <NewButton
                data-test-id="WebhooksTableActionCell__confirmButton"
                variant="flat"
                size="icon-sm"
                color="primary"
                :disabled="!isValid || updating"
                aria-label="confirm"
                @click="$emit('confirm-edit', true)"
            >
                <EidIcon :icon-src="faCheck" />
            </NewButton>
            <NewButton
                data-test-id="WebhooksTableActionCell__cancelButton"
                variant="flat"
                size="icon-sm"
                color="danger"
                :disabled="updating"
                aria-label="cancel"
                @click="$emit('confirm-edit', false)"
            >
                <EidIcon :icon-src="faTimes" />
            </NewButton>
        </div>
        <div v-else class="flex gap-1">
            <NewButton
                data-test-id="WebhooksTableActionCell__editButton"
                variant="flat"
                size="icon-sm"
                color="secondary"
                :disabled="updating"
                aria-label="edit"
                @click="$emit('edit')"
            >
                <EidIcon :icon-src="faPenToSquare" />
            </NewButton>
            <NewButton
                data-test-id="WebhooksTableActionCell__deleteButton"
                variant="flat"
                size="icon-sm"
                color="secondary"
                :disabled="updating"
                aria-label="delete"
                @click="$emit('delete')"
            >
                <EidIcon :icon-src="faXmark" />
            </NewButton>
        </div>
    </Cell>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
    import { faXmark, faPenToSquare } from '@fortawesome/pro-light-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { Cell } from '@evidentid/dashboard-commons/components/Table';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'WebhooksTableActionCell',
        components: {
            Cell,
            EidIcon,
            NewButton,
        },
        props: {
            isEditing: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            isValid: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            updating: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'confirm-edit', 'delete', 'edit' ],
        data() {
            return {
                faCheck,
                faTimes,
                faXmark,
                faPenToSquare,
            };
        },
    });
</script>
